import React, { useContext, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import SideBar from './Components/SideBar';
import Cat from './Components/Cat';
import Subcat from './Components/Subcat';
import { MyContext } from './Context/MyContext';
import Login from './Components/Login';
import Post from './Components/Post';
import "./App.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BookingCategories from './Components/Booking/BookingCategories';
import SubCategories from './Components/SubCategories/SubCategories';
import Package from './Components/Package/Package';
import PackageCategories from './Components/PackageCategories/PackageCategories';
import YourBooking from './Components/YourBookings/YourBooking';
import Inquiries from './Components/Inquiries/Inquiries';
import Itinerary from './Components/Itinerary/Itinerary';
import ItineraryRequests from './Components/Itinerary/ItineraryRequests';
import FixedDepartures from './Components/FixedDepartures/FixedDepartures';



const App = () => {
  const { isLoggedIn } = useContext(MyContext);

  // Bootstrap 5.0.2 doesn't accept `backdrop:"static"` on offcanvas (throws
  // a type error). Emulate static behavior at the event level: track whether
  // the last mousedown landed on a real dismiss control, then cancel the
  // hide.bs.offcanvas event when it wasn't a dismiss click. Programmatic
  // hides (e.g. after form submit, via .btn-close.click()) also flip the
  // flag because they simulate a click on a dismiss button.
  useEffect(() => {
    let allowNextHide = false;
    const armIfDismiss = (e) => {
      const t = e.target;
      if (t && t.closest && t.closest('[data-bs-dismiss="offcanvas"]')) {
        allowNextHide = true;
      }
    };
    const onHide = (e) => {
      if (!allowNextHide) {
        e.preventDefault();
      }
      allowNextHide = false;
    };
    document.addEventListener('mousedown', armIfDismiss, true);
    document.addEventListener('click',     armIfDismiss, true);
    document.addEventListener('hide.bs.offcanvas', onHide, true);
    return () => {
      document.removeEventListener('mousedown', armIfDismiss, true);
      document.removeEventListener('click',     armIfDismiss, true);
      document.removeEventListener('hide.bs.offcanvas', onHide, true);
    };
  }, []);
  return (
    <>

   <ToastContainer/>
    <div className='row'>
      {
        isLoggedIn==true?<div className='col-2'>
        <SideBar/>
      </div>:null
      }

      {/* <div className='col-2'>
        <SideBar/>
      </div> */}
      
      {!isLoggedIn && (
        <div className="col-12 card-centered-body">
          <Routes>
            <Route exact path='/Login' Component={Login} />
          </Routes>
        </div>
      )}

      <div className='col-10'>
        <Routes>
          {/* <Route exact path='/Login' Component={Login}/> */}
          <Route exact path='/home' Component={Home}/>
          <Route exact path='/Cat' Component={Cat}/>
          <Route exact path='/SubCat' Component={Subcat}/>
          <Route exact path='/Post' Component={Post}/>
          <Route exact path='/BookingCategories' Component={BookingCategories}/>
          <Route exact path='/BookingSubCategories' Component={SubCategories}/>
          <Route exact path='/PackageCategories' Component={PackageCategories}/>
          <Route exact path='/bookings' Component={YourBooking}/>
          <Route exact path='/inquiries' Component={Inquiries}/>
          <Route exact path='/Package' Component={Package}/>
          <Route exact path='/Itinerary' Component={Itinerary}/>
          <Route exact path='/ItineraryRequests' Component={ItineraryRequests}/>
          <Route exact path='/FixedDepartures' Component={FixedDepartures}/>
        </Routes>
      </div>
    </div>
  
    </>
  )
}

export default App;

// import React, { useState } from "react";
// import { convertFromRaw, EditorState } from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";



// const App = () => {
//   // Array of editor states and content states
//   const [editors, setEditors] = useState([
//   ]);

//   const handleEditorStateChange = (editorState, index) => {
//     const updatedEditors = editors.map((editor, i) => 
//       i === index ? { ...editor, editorState } : editor
//     );
//     setEditors(updatedEditors);
//   };

//   const handleContentStateChange = (contentState, index) => {
//     const htmlContent = draftToHtml(contentState);
//     const updatedEditors = editors.map((editor, i) => 
//       i === index ? { ...editor, contentState: htmlContent } : editor
//     );
//     setEditors(updatedEditors);
//   };
//   const addEditor = () => {
//     setEditors([...editors, { editorState: EditorState.createEmpty(), contentState: "" }]);
//   };

//   return (
//     <div className="App">

      
//       <h2 onClick={()=>{addEditor()}}>Output </h2>



//       {editors.map((editor, index) => (
//         <div key={index} className="editor-container">
//           <Editor
//             editorState={editor.editorState}
//             toolbarClassName="editor-toolbar"
//             wrapperClassName="editor-wrapper"
//             editorClassName="editor"
//             onEditorStateChange={(state) => handleEditorStateChange(state, index)}
//             onContentStateChange={(content) => handleContentStateChange(content, index)}
            
//           />

//           <h2 onClick={()=>{addEditor()}}>Output {index + 1}</h2>
//           <pre>
//             <code>{editor.contentState}</code>
//           </pre>

//           <h2>Rendered {index + 1}</h2>
//           <div dangerouslySetInnerHTML={{ __html: editor.contentState }} />
//         </div>
//       ))}
//     </div>
//   );
// };

// export default App;
